// PhonePe Configuration Constants
export const PHONEPE_CONFIG = {
  SANDBOX: {
    BASE_URL: "https://api-preprod.phonepe.com/apis/pg-sandbox",
    MERCHANT_ID: import.meta.env.VITE_PHONEPE_MERCHANT_ID || "PGTESTPAYUAT",
    SALT_KEY: import.meta.env.VITE_PHONEPE_SALT_KEY || "099eb0cd-02cf-4e2a-8aca-3e6c6aff0399",
    SALT_INDEX: import.meta.env.VITE_PHONEPE_SALT_INDEX || "1",
  },
  PRODUCTION: {
    BASE_URL: "https://api.phonepe.com/apis/hermes",
    MERCHANT_ID: import.meta.env.VITE_PHONEPE_MERCHANT_ID || "",
    SALT_KEY: import.meta.env.VITE_PHONEPE_SALT_KEY || "",
    SALT_INDEX: import.meta.env.VITE_PHONEPE_SALT_INDEX || "1",
  },
}

export const getCurrentConfig = () => {
  const env = import.meta.env.VITE_PHONEPE_ENV || "sandbox"
  return env === "production" ? PHONEPE_CONFIG.PRODUCTION : PHONEPE_CONFIG.SANDBOX
}

export const PHONEPE_ENDPOINTS = {
  PAY: "/pg/v1/pay",
  STATUS: "/pg/v1/status",
  REFUND: "/pg/v1/refund",
}

export const REDIRECT_URLS = {
  SUCCESS: import.meta.env.VITE_PHONEPE_REDIRECT_URL || `${window.location.origin}/payment/callback`,
  CALLBACK: import.meta.env.VITE_PHONEPE_CALLBACK_URL || `${window.location.origin}/api/phonepe/callback`,
}

export const PAYMENT_STATUS = {
  PENDING: "PENDING",
  SUCCESS: "COMPLETED",
  FAILED: "FAILED",
  CANCELLED: "CANCELLED",
}

export const PHONEPE_RESPONSE_CODES = {
  SUCCESS: "PAYMENT_SUCCESS",
  PENDING: "PAYMENT_PENDING",
  FAILED: "PAYMENT_ERROR",
  CANCELLED: "PAYMENT_CANCELLED",
}

export interface PhonePePaymentRequest {
  merchantId: string
  merchantTransactionId: string
  merchantUserId: string
  amount: number
  redirectUrl: string
  redirectMode: "POST" | "REDIRECT"
  callbackUrl?: string
  mobileNumber?: string
  paymentInstrument: {
    type: "PAY_PAGE" | "UPI_COLLECT" | "UPI_INTENT"
    upiId?: string
  }
}

export interface PhonePePaymentResponse {
  success: boolean
  code: string
  message: string
  data?: {
    merchantId: string
    merchantTransactionId: string
    transactionId: string
    amount: number
    state: string
    responseCode: string
    paymentInstrument?: {
      type: string
      utr?: string
      cardType?: string
      pgTransactionId?: string
    }
    instrumentResponse?: {
      redirectInfo?: {
        url: string
        method: string
      }
    }
  }
}

export interface PhonePeStatusResponse {
  success: boolean
  code: string
  message: string
  data?: {
    merchantId: string
    merchantTransactionId: string
    transactionId: string
    amount: number
    state: "PENDING" | "COMPLETED" | "FAILED"
    responseCode: string
    paymentInstrument?: {
      type: string
      utr?: string
      cardType?: string
      pgTransactionId?: string
    }
  }
}
